var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "tab-header", attrs: { role: "tablist" } },
    [
      _c("span", {
        staticClass: "header-shadow",
        style: _vm.headerShadowStyle
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }